var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',{attrs:{"flat":""}},[_c('reminder-list',{attrs:{"contract":_vm.contract}}),_c('q-separator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }